import { useLocation } from 'react-router';

import { areFiltersDefault } from 'modules/search/helpers/areFiltersDefault';
import { hasLocation } from 'modules/search/helpers/sidefilters';
import type { SearchPageLocationState } from 'modules/search/pages/Search/types/SearchPageLocationState';
import type { SearchFacet } from 'modules/search/types/SearchFacet';
import {
  useSearchFiltersById,
  useSearchLocation,
  useSearchQuery,
  useSearchRadius,
  useSearchSort,
} from 'modules/search/zustand-stores/searchStore';

type Args = {
  initialized: boolean;
  searchFacets: SearchFacet[];
};

export function useSearchFiltersSidebarState({
  initialized,
  searchFacets,
}: Args) {
  const location = useLocation<SearchPageLocationState>();

  const query = useSearchQuery();
  const sort = useSearchSort();
  const filters = useSearchFiltersById();
  const searchLocation = useSearchLocation();
  const searchRadius = useSearchRadius();

  const searchLocationActive = hasLocation(searchLocation);

  const defaultFiltersSet =
    areFiltersDefault(searchFacets, filters) && !searchLocationActive;

  return {
    sidebarReady: initialized,
    query,
    keywords: location.state?.remoteKeywords || [],
    sort,
    filters,
    defaultFiltersSet,
    searchLocation,
    searchRadius,
  };
}
